import React, { useEffect, useRef } from "react";
import { Button, Col, Form, Modal, Row } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import { addResult } from "../../../../../controller/api/__classic__/result";

export default (props) => {

  const [cookies] = useCookies(['lottmekong'])

  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const _onHide = () => {
    props.onHide()
  }

  const isMienBac = props.region === 'MB';

  const _mb_db = useRef('');
  const _mb_1 = useRef('');
  const _mb_2_1 = useRef('');
  const _mb_2_2 = useRef('');
  const _mb_3_1 = useRef('');
  const _mb_3_2 = useRef('');
  const _mb_3_3 = useRef('');
  const _mb_3_4 = useRef('');
  const _mb_3_5 = useRef('');
  const _mb_3_6 = useRef('');
  const _mb_4_1 = useRef('');
  const _mb_4_2 = useRef('');
  const _mb_4_3 = useRef('');
  const _mb_4_4 = useRef('');
  const _mb_5_1 = useRef('');
  const _mb_5_2 = useRef('');
  const _mb_5_3 = useRef('');
  const _mb_5_4 = useRef('');
  const _mb_5_5 = useRef('');
  const _mb_5_6 = useRef('');
  const _mb_6_1 = useRef('');
  const _mb_6_2 = useRef('');
  const _mb_6_3 = useRef('');
  const _mb_7_1 = useRef('');
  const _mb_7_2 = useRef('');
  const _mb_7_3 = useRef('');
  const _mb_7_4 = useRef('');

  const _db = useRef('');
  const _1 = useRef('');
  const _2 = useRef('');
  const _3_1 = useRef('');
  const _3_2 = useRef('');
  const _4_1 = useRef('');
  const _4_2 = useRef('');
  const _4_3 = useRef('');
  const _4_4 = useRef('');
  const _4_5 = useRef('');
  const _4_6 = useRef('');
  const _4_7 = useRef('');
  const _5 = useRef('');
  const _6_1 = useRef('');
  const _6_2 = useRef('');
  const _6_3 = useRef('');
  const _7 = useRef('');
  const _8 = useRef('');

  const mbInputRefs = useRef([]);
  const mntInputRefs = useRef([]);

  const mbFieldOrder = [
    { ref: _mb_7_1, max: 2 }, { ref: _mb_7_2, max: 2 }, { ref: _mb_7_3, max: 2 }, { ref: _mb_7_4, max: 2 },
    { ref: _mb_6_1, max: 3 }, { ref: _mb_6_2, max: 3 }, { ref: _mb_6_3, max: 3 },
    { ref: _mb_5_1, max: 4 }, { ref: _mb_5_2, max: 4 }, { ref: _mb_5_3, max: 4 },
    { ref: _mb_5_4, max: 4 }, { ref: _mb_5_5, max: 4 }, { ref: _mb_5_6, max: 4 },
    { ref: _mb_4_1, max: 4 }, { ref: _mb_4_2, max: 4 }, { ref: _mb_4_3, max: 4 }, { ref: _mb_4_4, max: 4 },
    { ref: _mb_3_1, max: 5 }, { ref: _mb_3_2, max: 5 }, { ref: _mb_3_3, max: 5 },
    { ref: _mb_3_4, max: 5 }, { ref: _mb_3_5, max: 5 }, { ref: _mb_3_6, max: 5 },
    { ref: _mb_2_1, max: 5 }, { ref: _mb_2_2, max: 5 },
    { ref: _mb_1, max: 5 },
    { ref: _mb_db, max: 5 }
  ];

  const mntFieldOrder = [
    { ref: _8, max: 2 },
    { ref: _7, max: 3 },
    { ref: _6_1, max: 4 }, { ref: _6_2, max: 4 }, { ref: _6_3, max: 4 },
    { ref: _5, max: 4 },
    { ref: _4_1, max: 5 }, { ref: _4_2, max: 5 }, { ref: _4_3, max: 5 }, { ref: _4_4, max: 5 },
    { ref: _4_5, max: 5 }, { ref: _4_6, max: 5 }, { ref: _4_7, max: 5 },
    { ref: _3_1, max: 5 }, { ref: _3_2, max: 5 },
    { ref: _2, max: 5 },
    { ref: _1, max: 5 },
    { ref: _db, max: 6 }
  ];

  const createHandler = (ref, maxLength, inputIndex, inputRefs) => (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, maxLength);
    ref.current = value;
    e.target.value = value;
    
    if (value.length === maxLength && inputRefs.current[inputIndex + 1]) {
      inputRefs.current[inputIndex + 1].focus();
    }
  };

  useEffect(() => {
    const _result = props.result && props.result.length > 0 ? props.result : [];
    
    if (isMienBac) {
      _mb_db.current = _result[0] || '';
      _mb_1.current = _result[1] || '';
      
      const g2Parts = ((_result[2] || '').toString() || '').split(/\s+/).filter(p => p);
      _mb_2_1.current = g2Parts[0] || '';
      _mb_2_2.current = g2Parts[1] || '';
      
      const g3Parts = ((_result[3] || '').toString() || '').split(/\s+/).filter(p => p);
      _mb_3_1.current = g3Parts[0] || '';
      _mb_3_2.current = g3Parts[1] || '';
      _mb_3_3.current = g3Parts[2] || '';
      _mb_3_4.current = g3Parts[3] || '';
      _mb_3_5.current = g3Parts[4] || '';
      _mb_3_6.current = g3Parts[5] || '';
      
      const g4Parts = ((_result[4] || '').toString() || '').split(/\s+/).filter(p => p);
      _mb_4_1.current = g4Parts[0] || '';
      _mb_4_2.current = g4Parts[1] || '';
      _mb_4_3.current = g4Parts[2] || '';
      _mb_4_4.current = g4Parts[3] || '';
      
      const g5Parts = ((_result[5] || '').toString() || '').split(/\s+/).filter(p => p);
      _mb_5_1.current = g5Parts[0] || '';
      _mb_5_2.current = g5Parts[1] || '';
      _mb_5_3.current = g5Parts[2] || '';
      _mb_5_4.current = g5Parts[3] || '';
      _mb_5_5.current = g5Parts[4] || '';
      _mb_5_6.current = g5Parts[5] || '';
      
      const g6Parts = ((_result[6] || '').toString() || '').split(/\s+/).filter(p => p);
      _mb_6_1.current = g6Parts[0] || '';
      _mb_6_2.current = g6Parts[1] || '';
      _mb_6_3.current = g6Parts[2] || '';
      
      const g7Parts = ((_result[7] || '').toString() || '').split(/\s+/).filter(p => p);
      _mb_7_1.current = g7Parts[0] || '';
      _mb_7_2.current = g7Parts[1] || '';
      _mb_7_3.current = g7Parts[2] || '';
      _mb_7_4.current = g7Parts[3] || '';

      // Sync DOM values
      mbInputRefs.current.forEach((input, idx) => {
        if (input) {
          const refs = [_mb_7_1, _mb_7_2, _mb_7_3, _mb_7_4, _mb_6_1, _mb_6_2, _mb_6_3,
            _mb_5_1, _mb_5_2, _mb_5_3, _mb_5_4, _mb_5_5, _mb_5_6,
            _mb_4_1, _mb_4_2, _mb_4_3, _mb_4_4,
            _mb_3_1, _mb_3_2, _mb_3_3, _mb_3_4, _mb_3_5, _mb_3_6,
            _mb_2_1, _mb_2_2, _mb_1, _mb_db];
          if (refs[idx]) input.value = refs[idx].current;
        }
      });
    } else {
      _db.current = _result[0] || '';
      _1.current = _result[1] || '';
      _2.current = _result[2] || '';
      
      const g3Parts = ((_result[3] || '').toString() || '').split(/\s+/).filter(p => p);
      _3_1.current = g3Parts[0] || '';
      _3_2.current = g3Parts[1] || '';
      
      const g4Parts = ((_result[4] || '').toString() || '').split(/\s+/).filter(p => p);
      _4_1.current = g4Parts[0] || '';
      _4_2.current = g4Parts[1] || '';
      _4_3.current = g4Parts[2] || '';
      _4_4.current = g4Parts[3] || '';
      _4_5.current = g4Parts[4] || '';
      _4_6.current = g4Parts[5] || '';
      _4_7.current = g4Parts[6] || '';
      
      _5.current = _result[5] || '';
      
      const g6Parts = ((_result[6] || '').toString() || '').split(/\s+/).filter(p => p);
      _6_1.current = g6Parts[0] || '';
      _6_2.current = g6Parts[1] || '';
      _6_3.current = g6Parts[2] || '';
      
      _7.current = _result[7] || '';
      _8.current = _result[8] || '';

      // Sync DOM values
      mntInputRefs.current.forEach((input, idx) => {
        if (input) {
          const refs = [_8, _7, _6_1, _6_2, _6_3, _5,
            _4_1, _4_2, _4_3, _4_4, _4_5, _4_6, _4_7,
            _3_1, _3_2, _2, _1, _db];
          if (refs[idx]) input.value = refs[idx].current;
        }
      });
    }
    forceUpdate();
  }, [props.id, props.result, forceUpdate, isMienBac]);

  const onSubmitMienBac = async () => {
    const db = _mb_db.current.trim();
    if (!db || db.length !== 5 || !/^\d{5}$/.test(db)) {
      alert('Giải ĐB phải có đúng 5 số');
      return false;
    }

    const g1 = _mb_1.current.trim();
    if (!g1 || g1.length !== 5 || !/^\d{5}$/.test(g1)) {
      alert('Giải Nhất phải có đúng 5 số');
      return false;
    }

    const g2_values = [_mb_2_1, _mb_2_2];
    for (let i = 0; i < g2_values.length; i++) {
      const val = g2_values[i].current.trim();
      if (!val || val.length !== 5 || !/^\d{5}$/.test(val)) {
        alert(`Giải Nhì - ô ${i + 1} phải có đúng 5 số`);
        return false;
      }
    }

    const g3_values = [_mb_3_1, _mb_3_2, _mb_3_3, _mb_3_4, _mb_3_5, _mb_3_6];
    for (let i = 0; i < g3_values.length; i++) {
      const val = g3_values[i].current.trim();
      if (!val || val.length !== 5 || !/^\d{5}$/.test(val)) {
        alert(`Giải Ba - ô ${i + 1} phải có đúng 5 số`);
        return false;
      }
    }

    const g4_values = [_mb_4_1, _mb_4_2, _mb_4_3, _mb_4_4];
    for (let i = 0; i < g4_values.length; i++) {
      const val = g4_values[i].current.trim();
      if (!val || val.length !== 4 || !/^\d{4}$/.test(val)) {
        alert(`Giải Tư - ô ${i + 1} phải có đúng 4 số`);
        return false;
      }
    }

    const g5_values = [_mb_5_1, _mb_5_2, _mb_5_3, _mb_5_4, _mb_5_5, _mb_5_6];
    for (let i = 0; i < g5_values.length; i++) {
      const val = g5_values[i].current.trim();
      if (!val || val.length !== 4 || !/^\d{4}$/.test(val)) {
        alert(`Giải Năm - ô ${i + 1} phải có đúng 4 số`);
        return false;
      }
    }

    const g6_values = [_mb_6_1, _mb_6_2, _mb_6_3];
    for (let i = 0; i < g6_values.length; i++) {
      const val = g6_values[i].current.trim();
      if (!val || val.length !== 3 || !/^\d{3}$/.test(val)) {
        alert(`Giải Sáu - ô ${i + 1} phải có đúng 3 số`);
        return false;
      }
    }

    const g7_values = [_mb_7_1, _mb_7_2, _mb_7_3, _mb_7_4];
    for (let i = 0; i < g7_values.length; i++) {
      const val = g7_values[i].current.trim();
      if (!val || val.length !== 2 || !/^\d{2}$/.test(val)) {
        alert(`Giải Bảy - ô ${i + 1} phải có đúng 2 số`);
        return false;
      }
    }

    const result = [
      db,
      g1,
      `${_mb_2_1.current} ${_mb_2_2.current}`,
      `${_mb_3_1.current} ${_mb_3_2.current} ${_mb_3_3.current} ${_mb_3_4.current} ${_mb_3_5.current} ${_mb_3_6.current}`,
      `${_mb_4_1.current} ${_mb_4_2.current} ${_mb_4_3.current} ${_mb_4_4.current}`,
      `${_mb_5_1.current} ${_mb_5_2.current} ${_mb_5_3.current} ${_mb_5_4.current} ${_mb_5_5.current} ${_mb_5_6.current}`,
      `${_mb_6_1.current} ${_mb_6_2.current} ${_mb_6_3.current}`,
      `${_mb_7_1.current} ${_mb_7_2.current} ${_mb_7_3.current} ${_mb_7_4.current}`
    ];

    const resp = await addResult(cookies.lottmekong, props.id, result);
    if (resp) {
      props.callback(result);
      _onHide();
    } else {
      alert('Có lỗi xảy ra');
      return false;
    }
  };

  const onSubmitMienNamTrung = async () => {
    const db = _db.current.trim();
    if (!db || db.length !== 6 || !/^\d{6}$/.test(db)) {
      alert('Giải đặc biệt phải có đúng 6 số');
      return false;
    }

    const g1 = _1.current.trim();
    if (!g1 || g1.length !== 5 || !/^\d{5}$/.test(g1)) {
      alert('Giải 1 phải có đúng 5 số');
      return false;
    }

    const g2 = _2.current.trim();
    if (!g2 || g2.length !== 5 || !/^\d{5}$/.test(g2)) {
      alert('Giải 2 phải có đúng 5 số');
      return false;
    }

    const g3_1 = _3_1.current.trim();
    const g3_2 = _3_2.current.trim();
    if (!g3_1 || g3_1.length !== 5 || !/^\d{5}$/.test(g3_1)) {
      alert('Giải 3 - ô 1 phải có đúng 5 số');
      return false;
    }
    if (!g3_2 || g3_2.length !== 5 || !/^\d{5}$/.test(g3_2)) {
      alert('Giải 3 - ô 2 phải có đúng 5 số');
      return false;
    }

    const g4_values = [_4_1, _4_2, _4_3, _4_4, _4_5, _4_6, _4_7];
    for (let i = 0; i < g4_values.length; i++) {
      const val = g4_values[i].current.trim();
      if (!val || val.length !== 5 || !/^\d{5}$/.test(val)) {
        alert(`Giải 4 - ô ${i + 1} phải có đúng 5 số`);
        return false;
      }
    }

    const g5 = _5.current.trim();
    if (!g5 || g5.length !== 4 || !/^\d{4}$/.test(g5)) {
      alert('Giải 5 phải có đúng 4 số');
      return false;
    }

    const g6_1 = _6_1.current.trim();
    const g6_2 = _6_2.current.trim();
    const g6_3 = _6_3.current.trim();
    if (!g6_1 || g6_1.length !== 4 || !/^\d{4}$/.test(g6_1)) {
      alert('Giải 6 - ô 1 phải có đúng 4 số');
      return false;
    }
    if (!g6_2 || g6_2.length !== 4 || !/^\d{4}$/.test(g6_2)) {
      alert('Giải 6 - ô 2 phải có đúng 4 số');
      return false;
    }
    if (!g6_3 || g6_3.length !== 4 || !/^\d{4}$/.test(g6_3)) {
      alert('Giải 6 - ô 3 phải có đúng 4 số');
      return false;
    }

    const g7 = _7.current.trim();
    if (!g7 || g7.length !== 3 || !/^\d{3}$/.test(g7)) {
      alert('Giải 7 phải có đúng 3 số');
      return false;
    }

    const g8 = _8.current.trim();
    if (!g8 || g8.length !== 2 || !/^\d{2}$/.test(g8)) {
      alert('Giải 8 phải có đúng 2 số');
      return false;
    }

    const result = [
      db,
      g1,
      g2,
      `${g3_1} ${g3_2}`,
      `${_4_1.current} ${_4_2.current} ${_4_3.current} ${_4_4.current} ${_4_5.current} ${_4_6.current} ${_4_7.current}`,
      g5,
      `${g6_1} ${g6_2} ${g6_3}`,
      g7,
      g8
    ];

    const resp = await addResult(cookies.lottmekong, props.id, result);
    if (resp) {
      props.callback(result);
      _onHide();
    } else {
      alert('Có lỗi xảy ra');
      return false;
    }
  };

  const onSubmit = isMienBac ? onSubmitMienBac : onSubmitMienNamTrung;

  const renderMienBacForm = () => {
    let inputIndex = 0;
    mbInputRefs.current = [];

    return (
      <Form>
        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G. Bảy</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <Row className="g-2">
              {[_mb_7_1, _mb_7_2, _mb_7_3, _mb_7_4].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={3} key={`g7-${idx}`}>
                    <Form.Control
                      ref={el => mbInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 2, currentIndex, mbInputRefs)}
                      maxLength={2}
                    />
                  </Col>
                );
              })}
            </Row>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>4 dãy x 2 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G. Sáu</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <Row className="g-2">
              {[_mb_6_1, _mb_6_2, _mb_6_3].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={4} key={`g6-${idx}`}>
                    <Form.Control
                      ref={el => mbInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 3, currentIndex, mbInputRefs)}
                      maxLength={3}
                    />
                  </Col>
                );
              })}
            </Row>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>3 dãy x 3 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G. Năm</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <Row className="g-2 mb-1">
              {[_mb_5_1, _mb_5_2, _mb_5_3].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={4} key={`g5-${idx}`}>
                    <Form.Control
                      ref={el => mbInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 4, currentIndex, mbInputRefs)}
                      maxLength={4}
                    />
                  </Col>
                );
              })}
            </Row>
            <Row className="g-2">
              {[_mb_5_4, _mb_5_5, _mb_5_6].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={4} key={`g5-${idx + 3}`}>
                    <Form.Control
                      ref={el => mbInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 4, currentIndex, mbInputRefs)}
                      maxLength={4}
                    />
                  </Col>
                );
              })}
            </Row>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>6 dãy x 4 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G. Tư</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <Row className="g-2">
              {[_mb_4_1, _mb_4_2, _mb_4_3, _mb_4_4].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={3} key={`g4-${idx}`}>
                    <Form.Control
                      ref={el => mbInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 4, currentIndex, mbInputRefs)}
                      maxLength={4}
                    />
                  </Col>
                );
              })}
            </Row>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>4 dãy x 4 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G. Ba</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <Row className="g-2 mb-1">
              {[_mb_3_1, _mb_3_2, _mb_3_3].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={4} key={`g3-${idx}`}>
                    <Form.Control
                      ref={el => mbInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 5, currentIndex, mbInputRefs)}
                      maxLength={5}
                    />
                  </Col>
                );
              })}
            </Row>
            <Row className="g-2">
              {[_mb_3_4, _mb_3_5, _mb_3_6].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={4} key={`g3-${idx + 3}`}>
                    <Form.Control
                      ref={el => mbInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 5, currentIndex, mbInputRefs)}
                      maxLength={5}
                    />
                  </Col>
                );
              })}
            </Row>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>6 dãy x 5 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G. Nhì</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <Row className="g-2">
              {[_mb_2_1, _mb_2_2].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={6} key={`g2-${idx}`}>
                    <Form.Control
                      ref={el => mbInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 5, currentIndex, mbInputRefs)}
                      maxLength={5}
                    />
                  </Col>
                );
              })}
            </Row>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>2 dãy x 5 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G. Nhất</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <div className="d-flex justify-content-center">
              <Form.Control
                ref={el => mbInputRefs.current[inputIndex] = el}
                type="text"
                size="sm"
                style={{ width: '140px', textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                defaultValue={_mb_1.current}
                onChange={createHandler(_mb_1, 5, inputIndex++, mbInputRefs)}
                maxLength={5}
              />
            </div>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>5 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>ĐB</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <div className="d-flex justify-content-center">
              <Form.Control
                ref={el => mbInputRefs.current[inputIndex] = el}
                type="text"
                size="sm"
                style={{ width: '140px', textAlign: 'center', fontSize: '18px', fontWeight: 'bold', color: '#dc3545' }}
                defaultValue={_mb_db.current}
                onChange={createHandler(_mb_db, 5, inputIndex++, mbInputRefs)}
                maxLength={5}
              />
            </div>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>5 số</Form.Text>
          </Col>
        </Row>
      </Form>
    );
  };

  const renderMienNamTrungForm = () => {
    let inputIndex = 0;
    mntInputRefs.current = [];

    const renderSingleInput = (ref, maxLength, width, style = {}) => {
      const currentIndex = inputIndex++;
      return (
        <Form.Control
          ref={el => mntInputRefs.current[currentIndex] = el}
          required
          type="text"
          size="sm"
          style={{ width, textAlign: 'center', fontSize: '16px', fontWeight: 'bold', ...style }}
          defaultValue={ref.current}
          onChange={createHandler(ref, maxLength, currentIndex, mntInputRefs)}
          maxLength={maxLength}
        />
      );
    };

    return (
      <Form>
        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G.8</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <div className="d-flex justify-content-center">
              {renderSingleInput(_8, 2, '80px')}
            </div>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>2 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G.7</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <div className="d-flex justify-content-center">
              {renderSingleInput(_7, 3, '100px')}
            </div>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>3 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G.6</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <Row className="g-2">
              {[_6_1, _6_2, _6_3].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={4} key={`g6-${idx}`}>
                    <Form.Control
                      ref={el => mntInputRefs.current[currentIndex] = el}
                      required
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 4, currentIndex, mntInputRefs)}
                      maxLength={4}
                    />
                  </Col>
                );
              })}
            </Row>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>3 dãy x 4 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G.5</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <div className="d-flex justify-content-center">
              {renderSingleInput(_5, 4, '120px')}
            </div>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>4 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G.4</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <Row className="g-2 mb-2">
              {[_4_1, _4_2].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={6} key={`g4-${idx}`}>
                    <Form.Control
                      ref={el => mntInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 5, currentIndex, mntInputRefs)}
                      maxLength={5}
                    />
                  </Col>
                );
              })}
            </Row>
            <Row className="g-2 mb-2">
              {[_4_3, _4_4].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={6} key={`g4-${idx + 2}`}>
                    <Form.Control
                      ref={el => mntInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 5, currentIndex, mntInputRefs)}
                      maxLength={5}
                    />
                  </Col>
                );
              })}
            </Row>
            <Row className="g-2">
              {[_4_5, _4_6, _4_7].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={4} key={`g4-${idx + 4}`}>
                    <Form.Control
                      ref={el => mntInputRefs.current[currentIndex] = el}
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 5, currentIndex, mntInputRefs)}
                      maxLength={5}
                    />
                  </Col>
                );
              })}
            </Row>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>7 dãy x 5 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G.3</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <Row className="g-2">
              {[_3_1, _3_2].map((ref, idx) => {
                const currentIndex = inputIndex++;
                return (
                  <Col xs={6} key={`g3-${idx}`}>
                    <Form.Control
                      ref={el => mntInputRefs.current[currentIndex] = el}
                      required
                      type="text"
                      size="sm"
                      style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}
                      defaultValue={ref.current}
                      onChange={createHandler(ref, 5, currentIndex, mntInputRefs)}
                      maxLength={5}
                    />
                  </Col>
                );
              })}
            </Row>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>2 dãy x 5 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G.2</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <div className="d-flex justify-content-center">
              {renderSingleInput(_2, 5, '140px')}
            </div>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>5 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>G.1</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <div className="d-flex justify-content-center">
              {renderSingleInput(_1, 5, '140px')}
            </div>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>5 số</Form.Text>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={3} className="d-flex align-items-center">
            <Form.Label className="mb-0"><strong>ĐB</strong></Form.Label>
          </Col>
          <Col xs={9}>
            <div className="d-flex justify-content-center">
              {renderSingleInput(_db, 6, '160px', { fontSize: '18px', color: '#dc3545' })}
            </div>
            <Form.Text className="text-muted" style={{fontSize: '11px'}}>6 số</Form.Text>
          </Col>
        </Row>
      </Form>
    );
  };

  return (
    <Modal
      {...props}
      key={props.id}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={_onHide}
    >
      <Modal.Header closeButton className="py-2">
        <Modal.Title id="contained-modal-title-vcenter">
          {props.channelName ? `Nhập kết quả ${props.channelName}` : `Nhập kết quả kiến thiết ${isMienBac ? 'Miền Bắc' : (props.region === 'MN' ? 'Miền Nam' : 'Miền Trung')}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-2 px-3" key={props.id}>
        {isMienBac ? renderMienBacForm() : renderMienNamTrungForm()}
      </Modal.Body>
      <Modal.Footer className="py-2">
        <Button variant="danger" size="sm" onClick={_onHide}>Đóng</Button>
        {props.canUpdate &&
          <Button variant="primary" size="sm" onClick={onSubmit}>Lưu kết quả</Button>
        }
      </Modal.Footer>
    </Modal>
  );
}
